import React from "react";
import { FaBoxesPacking, FaDesktop, FaTruckFast } from "react-icons/fa6";
import accessories from "../assets/banner5.jpg";

export default function SupplyAccessories() {
  const features = [
    {
      icon: <FaDesktop size={20} className="text-primary" />,
      text: "Technology procurement support aligned with solution design and deployment needs.",
    },
    {
      icon: <FaBoxesPacking size={20} className="text-primary" />,
      text: "Structured sourcing and rollout planning that supports smooth implementation.",
    },
    {
      icon: <FaTruckFast size={20} className="text-primary" />,
      text: "Deployment coordination that keeps the technology layer aligned with operational goals.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Extended Capability</div>
          <h2 className="main-section-title">Technology Procurement & Deployment</h2>
          <p className="section-copy">
            Nova Technologies supports organizations that need the right technology stack
            delivered with coordination and implementation awareness.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={accessories} alt="Technology Procurement and Deployment" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Procurement works best when it is tied directly to solution outcomes. This
            capability area helps clients connect sourcing decisions with actual deployment
            plans, system fit, and long-term operational usefulness.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Clarify required platforms, devices, or supporting technology layers.</li>
            <li>Align procurement choices with implementation priorities.</li>
            <li>Coordinate deployment with the wider solution rollout plan.</li>
            <li>Support handover and post-deployment stabilization.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
